<template>
    <div class="toogle-block">
        <div class="toogle-block-title">
            {{titleMsg}}
            <img @click="toggleClose" :src="arrowImg" :style="{transform: 'rotate('+arrowRotate+'deg)'}" alt="">
        </div>
        <div class="toogle-block-body" :class="{'close': close }">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            arrowImg: require('@/assets/img/icon/arrow_down_black.svg'),
            arrowRotate: '180',
            close: false
        }
    },
    props: {
        titleMsg: String,
    },
    watch: {
        close: function () {
            if(this.close){
                this.arrowImg = require('@/assets/img/icon/arrow_down_gray.svg'),
                this.arrowRotate = '0'
            }else{
                this.arrowImg = require('@/assets/img/icon/arrow_down_black.svg'),
                this.arrowRotate = '180'
            }
        },
    },
    methods: {
        toggleClose: function () {
            this.close = !this.close
        },
    }
}
</script>
<style lang="scss"  >
    .toogle-block{
        position: relative;
        width: 1154px;
        margin-bottom: 60px;
        .toogle-block-title{
            display: flex;
            justify-content: space-between;
            font-size: 20px;
            font-weight: 500;
            color: #ff9275;
            margin-bottom: 20px;
            padding-right: 22px;
        }
        .toogle-block-body.close{
            display: none;
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/components/widge/toogleBlock.vue